import React from 'react';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {
  ROUTE_PROFILE_INFO,
  ROUTE_SUPPORT,
  ROUTE_TUTORIAL,
} from '../../config/routes.config';
import { MenuItemListProps } from './menuItem.types';
import FeedbackIcon from '../../assets/icons/FeedbackIcon';

export const ITEM_SPACING = 3;
export const DRAWER_WIDTH = 240;

export const menuItems: MenuItemListProps = [
  {
    title: 'My profile',
    to: ROUTE_PROFILE_INFO,
    icon: <PersonOutlineIcon />,
  },
  {
    title: 'Support',
    to: ROUTE_SUPPORT,
    icon: <FeedbackIcon />,
  },
  {
    title: 'Tutorial',
    to: ROUTE_TUTORIAL,
    icon: <HelpOutlineIcon />,
  },
];
